import * as amplitude from '@amplitude/analytics-browser';
import config, { Environment } from '../config';

const apiKey = config.amplitudeApiKey;

export const ANALYTICS_ENABLED: boolean = config.environment !== Environment.local && !!apiKey;

if (ANALYTICS_ENABLED && apiKey) {
  amplitude.init(apiKey, { defaultTracking: false });
}
